let interestTypeOptions = [
  {
    label: '年利率',
    value: 'Yearly'
  },
  {
    label: '月利率',
    value: 'Monthly'
  },
  {
    label: '日利率',
    value: 'Daily'
  }
]

export default interestTypeOptions



// WEBPACK FOOTER //
// ./src/utils/interestTypeOptions.js